import { render } from "./FooterMenu.vue?vue&type=template&id=6955de8a"
import script from "./FooterMenu.vue?vue&type=script&lang=js"
export * from "./FooterMenu.vue?vue&type=script&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=6955de8a&lang=css"

import exportComponent from "C:\\Users\\VR-DEV001\\Documents\\repositorios\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__